export default __webpack_public_path__ + "static/Suburb-d73011a422a6cfb349ef7bbc69f96dd1.webp";